import { render, staticRenderFns } from "./ClientProgramsTable.vue?vue&type=template&id=af41a498&"
import script from "./ClientProgramsTable.vue?vue&type=script&lang=js&"
export * from "./ClientProgramsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports